export const config = {
  API: process.env.VUE_APP_API_URL,
  MAP_KEY: ' pk.eyJ1IjoidG95b3RhbW90b3JldXJvcGUtd2ViIiwiYSI6ImNrNmtqZzM5ZTA0bjgzZXBiemJ1ZHYyNDcifQ.Yfrq8kataFBLbN293vWY9A'
  // SEO_API: `http://api.vinchecker.com.dev11.vintagedev.com.ua`
}
// sk.eyJ1IjoidG95b3Rhc2NyZWVuIiwiYSI6ImNsZHZreDgzcjAwdmwzdm51NnNydjI4NHUifQ.MXvUjXidZqc_mR5r9uW1Vw

const urlParams = new URLSearchParams(window.location.search)
const hasMdParam = urlParams.has('country') && urlParams.get('country') === 'md'

export const isMd = window.location.hostname.includes('md') || hasMdParam
